import {Component, inject, OnInit} from '@angular/core';
import moment from 'moment';

import {PermissionsService} from '@intocare/auth-data';

import {DashboardModel} from '../../model/dashboard.model';

@Component({
	selector: 'ic-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	standalone: false
})
export class DashboardComponent implements OnInit {
	private permissionsService = inject(PermissionsService);
	private readonly dashBoardModel = inject(DashboardModel);

	protected date$ = this.dashBoardModel.date$;
	protected hasTasksPermission = this.permissionsService.userHasPermissions('PORTAL.TASKS_WIDGET');
	protected hasAlarmsPermission = this.permissionsService.userHasPermissions('PORTAL.ALARMS_WIDGET');

	protected setDate(date: string) {
		this.dashBoardModel.setDate(date);
	}

	ngOnInit(): void {
		this.setDate(moment().format('YYYY-MM-DD'));
	}
}
